// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"8547eeaf","176":"1c3c033a","245":"fbaf8ed2","377":"234aa34c","477":"b5f1f005","503":"dcaa29e5","616":"cedcabc7","869":"234aa34c"}[chunkId] + ".chunk.css";
};